import type { FaireProductEntity } from "../../entity_types/product";

export const p_mcc6v37qhx: FaireProductEntity = {
  token: "p_mcc6v37qhx",
  type: "product",
  name: "Campfire Smore Summer Candles - Wholesale Farmhouse Candle",
  brandName: "Driftless Studios",
  imageUrl:
    "https://cdn.faire.com/fastly/b6a8479f657baed57921cca2d96b1b4814c0fc82d2dc177dbcbe97192e2f1c26.jpeg",
  priceDollars: 9.95,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/92d772461b621d46b78bd7b902229ec5ea327f5abc53ba459e2b6a406e3ae1ea.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
